export default "__VITE_ASSET__CIQ6kspb__"